import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { AccountTypeID } from "../../config/Constants"
import AutoFilterLocation from "./LocationModel/AutoFilterLocation"
import AutoFilterCompany from "../Companies/CompanyModel/AutoFilterCompany"

export default function AutoFilterLocationsGetObservable(company: number, region: number | string, filter: string, portal: number = 0, hideInactive: boolean = false): Observable<AutoFilterLocation[]> {
  const options = {
    AccountType: AccountTypeID,
    ImplementationID: portal,
    ParentAccountID: company,
    AutoFilterValue: filter,
    IsFilters: true,
    HideInactive: hideInactive
  }
  const requestBody: string = JSON.stringify(region ? { ...options, RegionID: region } : options)

  return ObservableFromFetch<AutoFilterLocation[]>("Order/GetAutoFilterLocation", requestBody)
}

export function AutoFilterLocationsGet(company: number, filter: string, hideInactive: boolean = false) {
  const requestBody = JSON.stringify({
    AccountType: AccountTypeID,
    ParentAccountID: company,
    AutoFilterValue: filter,
    IsFilters: true,
    HideInactive: hideInactive
  })

  return ObservableFromFetch<AutoFilterCompany[]>("Order/GetAutoFilterLocation", requestBody)
}

export function GetUserLocationsAdministrators(companyID: number, userID: number) {
  const requestBody: string = JSON.stringify({
    CompanyID: companyID,
    ApplicationUserID: userID
  }).toString()

  return ObservableFromFetch<string[]>("FFOrderUserFileMaintenance/GetUserLocationsAdministrators", requestBody)
}

export function AutoFilterLocationWithRegionGetObservable(regionId: number, filter: string): Observable<AutoFilterLocation[]> {
  const requestBody: string = JSON.stringify({
    ParentAccountID: "",
    AccountType: AccountTypeID,
    AutoFilterValue: filter,
    IncludeCompany: false,
    IncludeLocation: true,
    IncludeMaster: false,
    IncludeParent: true,
    IncludeRegion: false,
    RegionID: regionId
  })

  return ObservableFromFetch<AutoFilterLocation[]>("/Order/GetAutoFilterLocationWithRegion", requestBody)
}

export function AutoFilterLocationWithoutRegionGetObservable(): Observable<AutoFilterLocation[]> {
  const requestBody: string = JSON.stringify({
    //ParentAccountID: , // TODO: Need to corrected once authorized user data/account be available
    IncludeCompany: false,
    IncludeLocation: true,
    IncludeMaster: false,
    IncludeParent: true,
    IncludeRegion: false,
  })

  return ObservableFromFetch<AutoFilterLocation[]>("RandomTest/GetLocationWithoutRegion", requestBody)
}
